import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/clientAddresses'

class ClientAddressDataService extends RestApiDataService {

}

export default new ClientAddressDataService(BASE_ENTITY_URL)
